import { useTranslation } from 'react-i18next';

export default function LegalPage({ doc }) {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'ar' ? 'ar' : 'en';
  const d = doc[lang];
  const updatedLabel = lang === 'ar' ? 'آخر تحديث' : 'Last updated';

  return (
    <div className="relative overflow-hidden">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-64 opacity-20"
        style={{
          background:
            'radial-gradient(60% 100% at 50% 0%, var(--color-primary) 0%, transparent 60%)',
        }}
      />
      <article className="relative mx-auto max-w-3xl px-4 py-16 sm:py-20">
        <header className="border-b border-border pb-8">
          <h1 className="text-3xl font-bold sm:text-4xl">{d.title}</h1>
          <p className="mt-3 text-sm text-text-faint">
            {updatedLabel}: {d.updated}
          </p>
          <p className="mt-6 leading-relaxed text-text-muted">{d.intro}</p>
        </header>

        <div className="mt-10 space-y-10">
          {d.sections.map((section) => (
            <section key={section.heading}>
              <h2 className="text-xl font-semibold text-text">{section.heading}</h2>
              {section.paragraphs?.map((p, i) => (
                <p key={i} className="mt-3 leading-relaxed text-text-muted">
                  {p}
                </p>
              ))}
              {section.list && (
                <ul className="mt-4 space-y-2.5">
                  {section.list.map((item, i) => (
                    <li key={i} className="flex items-start gap-3 text-text-muted">
                      <span className="mt-2 inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
                      <span className="leading-relaxed">{item}</span>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </article>
    </div>
  );
}
